const { getElements, debounce } = window.BAO.Utils;
class BaoAccordion extends window.BAO.CustomElement() {
  static get styles() {
    return `
      :host {
        display: block;
      }
    `;
  }

  static get requiredElements() {
    return ["trigger", "panel"];
  }

  connectedCallback() {
    super.connectedCallback();

    this.observeWidth();

    this.els.trigger.element.setAttribute("aria-expanded", false);
    this.calculateHeight();
    this.resetPanel();
  }

  setupListeners() {
    super.setupListeners();

    this.listeners.add(
      this.els.trigger.element,
      "click",
      this.onTriggerClick.bind(this),
    );

    this.externalTriggerEls.forEach((externalTriggerEl) => {
      this.listeners.add(externalTriggerEl, "click", () => {
        this.toggle(true);
      });
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.resizeObserver.disconnect();
  }

  calculateHeight() {
    this.panelHeight = (() => {
      const panelIsHidden = this.els.panel.element.hidden;

      if (panelIsHidden) {
        this.els.panel.element.removeAttribute("hidden");
      }

      const height = this.els.panel.element.offsetHeight;

      return height;
    })();
  }

  resetPanel() {
    this.els.panel.element.style.overflow = "hidden";
    this.els.panel.element.style.height = "0";
  }

  onTriggerClick() {
    this.toggle(!this.open);
  }

  observeWidth() {
    const triggerEl = this.els?.trigger?.element;
    if (!triggerEl) return;

    this.previousWidth = triggerEl.clientWidth;
    this.resizeObserver.observe(triggerEl);
  }

  handleResize(entry) {
    this.previousWidth = entry.contentRect.width;
    this.els.panel.element.style.height = "auto";
    this.calculateHeight();
    this.els.panel.element.style.height = this.open ? this.panelHeight : 0;
  }

  /**
   * @param {boolean} open
   */
  toggle(open) {
    if (open === this.open) return;

    this.els.trigger.element.setAttribute("aria-expanded", open.toString());

    if (open) {
      window.BAO.Utils.slideDown(this.els.panel.element, this.panelHeight);
    } else {
      window.BAO.Utils.slideUp(this.els.panel.element, this.panelHeight);
    }
  }

  get open() {
    return this.els.trigger.element.getAttribute("aria-expanded") === "true";
  }

  get resizeObserver() {
    return new ResizeObserver(
      debounce((entries) => {
        const entry = entries.find(
          (entry) => entry?.contentRect?.width !== this.previousWidth,
        );
        if (!entry) return;
        this.handleResize(entry);
      }, 250),
    );
  }

  get externalTriggerEls() {
    return getElements(`[href="#${this.els.trigger.element?.id}"]`);
  }
}

if (!customElements.get("bao-accordion")) {
  customElements.define("bao-accordion", BaoAccordion);
}
